import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import { selectAppPersistRefreshInterval } from '@store/useAppStorePersist';

export const whatsNewCountKey = () => ['whatsNewCount'];

export const whatsNewCountFn = () => {
  return apiClient.get(`${APP_API_URL_V2}customer-dashboard-v2/whats-new/count-unwatched`);
};

const whatsNewCountSelect = ({
  data,
}: AxiosResponse<{ data: { countUnwatchedNews: number; success: boolean } }>) => {
  const { countUnwatchedNews } = data?.data;
  return countUnwatchedNews || 0;
};

export const useWhatsNewCountQuery = () => {
  const refreshInterval = selectAppPersistRefreshInterval();

  return useQuery({
    queryKey: whatsNewCountKey(),
    queryFn: whatsNewCountFn,
    refetchInterval: refreshInterval,
    select: whatsNewCountSelect,
  });
};
